"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconSubscript = void 0;
var _react = _interopRequireDefault(require("react"));
var AccessibleIcon = _interopRequireWildcard(require("@radix-ui/react-accessible-icon"));
var _Icons = require("../Icons.constants");
var _IconModule = _interopRequireDefault(require("../Icon.module.css"));
var _classnames = _interopRequireDefault(require("classnames"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var IconSubscript = _ref => {
  var className = _ref.className,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? _Icons.DEFAULT_LABEL : _ref$label,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? _Icons.DEFAULT_COLOR : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? _Icons.DEFAULT_SIZE : _ref$size,
    _ref$isFilled = _ref.isFilled,
    isFilled = _ref$isFilled === void 0 ? false : _ref$isFilled;
  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      height: size,
      width: size
    },
    className: (0, _classnames.default)(className, _IconModule.default.Container)
  }, /*#__PURE__*/_react.default.createElement(AccessibleIcon.Root, {
    label: label
  }, isFilled ? /*#__PURE__*/_react.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M2.29289 4.29289C2.68342 3.90237 3.31658 3.90237 3.70711 4.29289L8 8.58579L12.2929 4.29289C12.6834 3.90237 13.3166 3.90237 13.7071 4.29289C14.0976 4.68342 14.0976 5.31658 13.7071 5.70711L9.41421 10L13.7071 14.2929C14.0976 14.6834 14.0976 15.3166 13.7071 15.7071C13.3166 16.0976 12.6834 16.0976 12.2929 15.7071L8 11.4142L3.70711 15.7071C3.31658 16.0976 2.68342 16.0976 2.29289 15.7071C1.90237 15.3166 1.90237 14.6834 2.29289 14.2929L6.58579 10L2.29289 5.70711C1.90237 5.31658 1.90237 4.68342 2.29289 4.29289Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M19.4536 11.0395C18.7506 10.9215 18.0284 11.0485 17.4079 11.3993L17.4039 11.4016C16.7797 11.7583 16.2993 12.3257 16.0578 13.0048C15.8728 13.5252 16.1446 14.097 16.665 14.2821C17.1854 14.4671 17.7572 14.1952 17.9422 13.6748C18.0205 13.4547 18.1794 13.2626 18.3942 13.1392C18.6152 13.0148 18.8722 12.9699 19.1224 13.0119C19.3712 13.0537 19.5983 13.179 19.7663 13.367C19.9176 13.5451 20 13.7716 20 13.9998C20 14.2476 19.8838 14.4898 19.5207 14.782C19.138 15.0899 18.6279 15.3338 18.0734 15.5954C17.4928 15.8693 16.9096 16.2182 16.5128 16.8318C16.1176 17.443 16 18.1706 16 18.9998C16 19.5521 16.4477 19.9998 17 19.9998H21C21.5523 19.9998 22 19.5521 22 18.9998C22 18.4476 21.5523 17.9998 21 17.9998H18.1467C18.1619 17.968 18.1773 17.941 18.1922 17.9179C18.2804 17.7815 18.4473 17.6304 18.9266 17.4043L18.9828 17.3778C19.4858 17.1408 20.194 16.8072 20.7744 16.3402C21.3962 15.8399 22 15.0821 22 13.9998C22 13.2901 21.7439 12.5986 21.2778 12.0573L21.2696 12.0479C20.7977 11.5136 20.1566 11.1576 19.4536 11.0395Z",
    fill: color
  })) : /*#__PURE__*/_react.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M3 5L13 15M13 5L3 15M21 19.0001H17C17 17.5001 17.44 17.0001 18.5 16.5001C19.56 16.0001 21 15.3301 21 14.0001C21 13.5301 20.83 13.0701 20.52 12.7101C20.1999 12.3476 19.7649 12.1061 19.2879 12.026C18.811 11.9459 18.321 12.0321 17.9 12.2701C17.48 12.5101 17.16 12.8901 17 13.3401",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
exports.IconSubscript = IconSubscript;
//# sourceMappingURL=IconSubscript.js.map